export const EXTERNAL_LINKS = {
  privacyPolicy: "https://www.nowsta.com/privacy/",
  termsOfService: "https://www.nowsta.com/terms/",
};
